"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("src/components/Box"));
var IconButton = function (_a) {
    var _b = _a.gap, gap = _b === void 0 ? 2 : _b, reverse = _a.reverse, icon = _a.icon, children = _a.children;
    var label = react_1.default.createElement("span", null, children);
    return (react_1.default.createElement(Box_1.default, { gap: gap, alignItems: "center", justifyContent: "center" },
        reverse ? label : icon,
        reverse ? icon : label));
};
exports.default = (function (Component) {
    var withButton = function (_a) {
        var icon = _a.icon, reverse = _a.reverse, gap = _a.gap, children = _a.children, rest = __rest(_a, ["icon", "reverse", "gap", "children"]);
        return (react_1.default.createElement(Component, __assign({}, rest),
            !icon && children,
            icon && (react_1.default.createElement(IconButton, { icon: icon, reverse: reverse, gap: gap }, children))));
    };
    return withButton;
});
